module.exports = __webpack_public_path__ + "static/img/help4.44d013cd.jpg";